import { A11y } from 'swiper/modules'
import { BREAKPOINTS } from '../constants'

export const menuSliderPreset = {
  modules: [A11y],
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  spaceBetween: 0,
  speed: 300,
  watchOverflow: true,
  slideToClickedSlide: true,
  resistanceRatio: 0.85,
  navigation: false,
  pagination: false,
  breakpoints: {
    [BREAKPOINTS.XL]: {
      slidesPerView: 'auto',
      allowTouchMove: false,
    },
  },
}
